"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockResponse = exports.createMockOpportunity = exports.createMockFinancialHighlights = void 0;
const faker_1 = require("@faker-js/faker");
const __1 = require("..");
const __2 = require("../..");
const test_utils_1 = require("@hum/common/src/test-utils");
function createMockFinancialHighlights(overwrites) {
    return Object.assign({ targetRaise: faker_1.faker.datatype.float({ min: 100000 }), locationCountry: faker_1.faker.address.country(), locationCity: faker_1.faker.address.city(), selfReportedIndustry: (0, test_utils_1.randomlySelectObjectValue)(__2.NAICS_INDUSTRY_GROUP_OPTIONS), useOfFunds: (0, test_utils_1.randomlySelectEnum)(__2.UseOfFunds), revenueModel: (0, test_utils_1.randomlySelectObjectValue)(__2.REVENUE_MODEL_V6), fundingType: (0, test_utils_1.randomlySelectEnum)(__2.FundingType) }, overwrites);
}
exports.createMockFinancialHighlights = createMockFinancialHighlights;
function createMockOpportunity(overwrites = {}) {
    const status = (0, test_utils_1.randomlySelectEnum)(__1.FundingOpportunityStatus);
    const archiveReason = status === __1.FundingOpportunityStatus.ARCHIVED
        ? (0, test_utils_1.randomlySelectEnum)(__1.FundingOpportunityArchiveReason)
        : undefined;
    const archiveReasonText = archiveReason === __1.FundingOpportunityArchiveReason.OTHER
        ? faker_1.faker.lorem.sentence()
        : undefined;
    return Object.assign(Object.assign({ id: faker_1.faker.datatype.uuid(), companyId: faker_1.faker.datatype.number(), reportId: faker_1.faker.datatype.uuid(), reportType: __2.ReportType.TALCOTT, investorName: __2.InvestorName.TALCOTT, investorTestRating: __2.InvestorTestRating.TRUE, status,
        archiveReason,
        archiveReasonText, product: (0, test_utils_1.randomlySelectEnum)(__1.Product), financialHighlights: createMockFinancialHighlights({}), receivedOfferAt: faker_1.faker.date.past().toISOString(), archivedAt: faker_1.faker.date.past().toISOString(), unarchivedAt: faker_1.faker.date.past().toISOString(), interestedAt: faker_1.faker.date.past().toISOString(), createdAt: faker_1.faker.date.past().toISOString(), createdBy: faker_1.faker.name.firstName(), updatedAt: faker_1.faker.date.past().toISOString(), updatedBy: faker_1.faker.name.firstName() }, (0, __1.getStatusBools)(overwrites.status || status)), overwrites);
}
exports.createMockOpportunity = createMockOpportunity;
exports.mockResponse = [
    createMockOpportunity({
        status: __1.FundingOpportunityStatus.ACTIVE,
        product: __1.Product.SMARTRAISE,
        reportType: __2.ReportType.TALCOTT,
    }),
    createMockOpportunity({
        status: __1.FundingOpportunityStatus.ARCHIVED,
        product: __1.Product.SMARTRAISE,
        reportType: __2.ReportType.PEAK_ROCK,
    }),
];
//# sourceMappingURL=FundingOpportunity.factory.js.map